<template>
  <div v-if="sectionData" id="propertyViewSection">
    <template v-if="sectionParams">
      <h2>{{ sectionParams.title }}</h2>
    </template>
    <v-data-table
      class="property-view-section-table"
      :headers="tableHeaders"
      :items="sectionData"
      item
      hide-actions
    >
      <template v-slot:items="props">
        <td v-if="getValue(props.item)" id="tabularData" colspan="2">
          <h5 class="text-xs-left">
            {{ props.item.header }}
          </h5>
          <div class="property-view-section__sub-table">
            <v-data-table
              :headers="props.item.value.tableHeaders"
              :items="props.item.value.tableValues"
              item
              hide-actions
            >
              <template v-slot:items="tableProps">
                <tr>
                  <td class="text-xs-left">
                    {{ tableProps.item.text }}
                  </td>
                  <td v-if="props.item.key" class="text-xs-left">
                    {{ getPropertyValue(tableProps.item.key) }}
                  </td>
                  <td v-else class="text-xs-left">
                    {{ tableProps.item.value }}
                  </td>
                </tr>
              </template>
            </v-data-table>
          </div>
        </td>
        <template v-else>
          <td id="propertyViewFirstCol" class="text-xs-left">
            {{ props.item.text }}
          </td>
          <td v-if="props.item.key" class="text-xs-left py-2">
            {{ getPropertyValue(props.item.key) }}
          </td>
          <td
            v-else-if="typeof props.item.value === 'string'"
            class="text-xs-left py-2"
          >
            {{ props.item.value }}
          </td>
        </template>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  props: {
    sectionData: {
      required: true,
      validator: prop => typeof prop === 'object' || prop === null
    },
    sectionParams: {
      type: Object,
      default: () => {
        return {}
      }
    },
    propertyDetails: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      tableHeaders: [
        { text: '', value: '', sortable: false, width: '40%' },
        { text: '', value: '', sortable: false, width: '60%' }
      ]
    }
  },

  methods: {
    getPropertyValue(columnParam) {
      return this.propertyDetails[columnParam]
    },

    getValue(item) {
      return item.value && typeof item.value === 'object'
    }
  }
}
</script>

<style lang="sass">
#propertyViewSection h2
  font-weight: 300
  text-align: left
  text-transform: uppercase
  margin-left: 1rem
  @media only screen and (max-width: 600px)
    text-align: center
    margin: 2rem

#propertyViewSection .v-datatable thead tr
  height: 1px !important

#tabularData
  padding-top: 17px
  padding-left: 2rem !important

#tabularData h5
  font-weight: 600
  font-size: 13px

#propertyViewFirstCol
  font-weight: 600 !important
  padding-left: 2rem !important

.property-view-section-table
  thead
    display: none
</style>
